import { render, staticRenderFns } from "./DcrImportPage.vue?vue&type=template&id=594c7737&"
import script from "./DcrImportPage.vue?vue&type=script&lang=ts&"
export * from "./DcrImportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594c7737')) {
      api.createRecord('594c7737', component.options)
    } else {
      api.reload('594c7737', component.options)
    }
    module.hot.accept("./DcrImportPage.vue?vue&type=template&id=594c7737&", function () {
      api.rerender('594c7737', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DCR/DcrImportPage.vue"
export default component.exports